<template>
  <div class="field-of-fields" :class="{ 'no-label-margin': hideLabelSpacing }">
    <div
      class="row"
      v-for="(rowInput, rowIndex) of listRowInput"
      :key="'row' + rowIndex"
    >
      <div
        v-for="(item, index) of rowInput"
        :key="item.model + rowIndex + index"
        :class="getClassList(item)"
      >
        <template v-if="item.type === FORM_TYPE.ARRAY_OBJECT">
          <template v-if="!isNaN(modelData[item.size])">
            <template v-for="childRowIndex in Number(modelData[item.size])">
              <DetailSectionRowLayout
                :user="user"
                :key="'childRowIndex-' + childRowIndex"
                :modelData="modelData[item.model][childRowIndex - 1]"
                :isInlineAnswer="isInlineAnswer"
                labelKey="labelDetail"
                :listFields="item.items"
              />
            </template>
          </template>
        </template>
        <template
          v-else-if="
            [
              FORM_TYPE.SLOT,
              FORM_TYPE.SECTION,
              FORM_TYPE.BOOKING_SECTION,
            ].includes(item.type)
          "
        >
          <slot
            v-if="isItemShow(modelData, item, listFields)"
            :name="item.name"
          ></slot>
        </template>
        <template v-else-if="item.type === FORM_TYPE.TAG_HTML">
          <div v-html="replaceTagValue(item.model, modelData)"></div>
        </template>
        <template v-else-if="item.type === FORM_TYPE.CHECKBOX">
          <CheckboxGroupDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            :isInlineAnswer="isInlineAnswer"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :optionList="getOptionsListByLanguage(item)"
            :mapOptionListByLang="getMapOptionListByLanguage(item)"
            :hasOther="item.hasOther"
            :hiddenIconTooltip="hiddenIconTooltip"
            :visibleIconTooltip="visibleIconTooltip"
            :hasHiddenIcon="listHiddenIconFields.includes(item.model)"
            :isHtml="item.isHtml"
            :numberOfColumn="item.numberOfColumn"
            :textboxOption="item.textboxOption"
            :tagData="tagData"
            :builderField="builderField"
            @toggleVisible="handleClickToggleVisibility(item, $event)"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.RATING_GROUP">
          <RatingGroupDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :itemList="item.itemList"
            :gradeList="item.gradeList"
            :numberOfColumn="item.numberOfColumn"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.RATING">
          <StarRating
            v-if="isDisplayItem(item)"
            classList=""
            :disabled="true"
            :label="getDisplayLabel(item)"
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :hasOther="item.hasOther"
            :defaultValue="item.defaultValue"
            :value="modelData[item.model]"
            :isRequired="item.isRequired"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.PRODUCT_SELECTION">
          <ProductSelectionDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :productList="item.productList"
            :descriptionList="item.descriptionList"
            :priceList="item.priceList"
            :iconList="item.iconList"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.RADIO_TABLE">
          <RadioTableDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :optionList="getOptionsListByLanguage(item)"
            :itemList="item.itemList"
            :headerList="item.headerList"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.CHECKBOX_TABLE">
          <CheckboxTable
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :optionList="getOptionsListByLanguage(item)"
            :itemList="item.itemList"
            :headerList="item.headerList"
            :hasNote="item.hasNote"
            :noteHeader="item.noteHeader"
            v-model="modelData[item.model]"
            :isRequired="false"
            :isViewOnly="true"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.DAY_HOURS_SELECTOR">
          <DayHourSelectorDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :field="item"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.SIGNATURE_FIELD">
          <SignatureDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :field="item"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.TEXT_EDITOR">
          <div v-if="isDisplayItem(item)">
            <label v-if="getDisplayLabel(item) != null">
              {{ getDisplayLabel(item) }}
            </label>

            <div class="description" v-if="item.description">
              <div v-html="getFieldProperty(item, 'description')"></div>
            </div>
            <p
              class="detail-info"
              v-if="isDisplayItem(item)"
              v-html="modelData[item.model]"
            ></p>
          </div>
        </template>
        <template v-else-if="item.type === FORM_TYPE.HEADER">
          <h4 class="header-detail mb-1">
            {{ getDisplayLabel(item) }}
          </h4>

          <div class="description" v-if="item.description">
            <div v-html="getFieldProperty(item, 'description')"></div>
          </div>
        </template>
        <template v-else-if="item.type === FORM_TYPE.SUB_HEADER">
          <div
            class="sub-header-detail"
            v-if="
              !(item.isPrivate && editAccess === false) &&
              isItemShow(modelData, item, listFields)
            "
          >
            <h5>
              {{ getDisplayLabel(item) }}
            </h5>

            <div class="description" v-if="item.description">
              <div v-html="getFieldProperty(item, 'description')"></div>
            </div>
          </div>
        </template>
        <template v-else-if="item.type === FORM_TYPE.HTML">
          <div
            v-html="item.html"
            :style="{ margin: item.noMargin ? '0' : '0 15px' }"
          ></div>
        </template>
        <template v-else-if="item.type === FORM_TYPE.SEPARATOR">
          <hr style="margin-bottom: 0" />
        </template>
        <template v-else-if="item.type === FORM_TYPE.HTML_SELECTION">
          <HtmlSelectionDetail
            v-if="isDisplayItem(item)"
            :label="getDisplayLabel(item)"
            classList=""
            :name="item.model"
            :description="getFieldProperty(item, 'description')"
            :adminDescription="getFieldProperty(item, 'adminDescription')"
            :optionList="getOptionsListByLanguage(item)"
            :htmlList="item.htmlList"
            :isMulti="item.isMulti"
            :numberOfColumn="item.numberOfColumn"
            :value="modelData[item.model]"
          />
        </template>
        <template v-else-if="item.type === FORM_TYPE.FILE">
          <div v-if="isDisplayItem(item)">
            <div v-if="item.fileType === FILE_TYPES.IMAGE">
              <div v-if="item.showAtTop">
                <img
                  class="image-at-top"
                  :src="getDisplayValue(item, item.model)"
                />
              </div>
              <div v-else>
                <label v-if="getDisplayLabel(item) != null">
                  {{ getDisplayLabel(item) }}
                </label>
                <p class="detail-info">
                  <img
                    class="image-display"
                    :src="getDisplayValue(item, item.model)"
                  />
                </p>
              </div>
            </div>
            <div v-else>
              <label v-if="getDisplayLabel(item) != null">
                {{ getDisplayLabel(item) }}
              </label>
              <div class="view-document">
                <div v-if="typeof modelData[item.model] === 'object'">
                  File: {{ modelData[item.model].name }}
                </div>
                <div v-else>
                  <a
                    :href="convertToAbsolutePath(modelData[item.model])"
                    target="_blank"
                  >
                    <button
                      class="mylisting-button dark-button view-button mt-2"
                    >
                      View
                    </button>
                  </a>
                  <button
                    class="mylisting-button secondary-button mt-2"
                    @click="showDeleteFileConfirmDialog(item.model)"
                    v-if="showDeleteFile(item)"
                  >
                    {{ getLabelByKeys("BUTTONS.DELETE") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- Display value for list Textbox -->
        <template v-else-if="item.type === FORM_TYPE.LIST_TEXTBOX">
          <div
            v-if="
              modelData[item.labelModel] &&
              modelData[item.labelModel].length > 0
            "
          >
            <label>{{ item.label }}</label>
            <div class="row" style="margin-top: -8px">
              <div
                class="col-lg-6"
                v-for="(label, index) of modelData[item.labelModel]"
                :key="'textbox-' + index"
              >
                <label>
                  {{ label }}
                </label>
                <p>
                  {{ modelData[item.model][index] }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="isDisplayItem(item)">
            <div v-if="item.hideDetailLabel" class="space-empty-label"></div>
            <label v-if="getDisplayLabel(item) != null">
              <span v-if="showAge(item)">Age</span>
              <span v-else class="display-label"
                >{{ getDisplayLabel(item)
                }}<i
                  v-if="listAdminOnlyIconFields.includes(item.model)"
                  class="hidden-icon material-icons ml-2"
                  v-tooltip="'Admin Only'"
                >
                  admin_panel_settings
                </i>
                <i
                  v-if="listHiddenIconFields.includes(item.model)"
                  class="hidden-icon material-icons ml-2"
                  @click="handleClickToggleVisibility(item, true)"
                  v-tooltip="hiddenIconTooltip"
                >
                  visibility_off
                </i>

                <i
                  v-if="item.additionalIcon"
                  class="hidden-icon material-icons ml-2"
                  style="cursor: pointer"
                  v-tooltip="item.additionalIconTooltip"
                  @click="$emit('additionalIconClick', item)"
                >
                  {{ item.additionalIcon }}
                </i>
              </span>
              <span v-if="isInlineAnswer">:</span>
            </label>
            <div v-if="isInlineAnswer" class="inline-answer">
              <p
                class="detail-info"
                v-if="['phone', 'phone2'].includes(item.model)"
              >
                <a :href="`tel:${getDisplayValue(item, item.model)}`">{{
                  getDisplayValue(item, item.model)
                }}</a>
              </p>
              <p
                class="detail-info"
                v-else-if="item.type === FORM_TYPE.RADIO && item.isHtml"
              >
                <span v-html="getDisplayValue(item, item.model)" />
              </p>
              <p class="detail-info" v-else>
                <span>{{ getDisplayValue(item, item.model) }}</span>
              </p>
            </div>

            <div class="description" v-if="item.description">
              <div v-html="getFieldProperty(item, 'description')"></div>
            </div>
            <div v-if="!isInlineAnswer">
              <p
                class="detail-info"
                v-if="['phone', 'phone2'].includes(item.model)"
              >
                <a :href="`tel:${getDisplayValue(item, item.model)}`">{{
                  getDisplayValue(item, item.model)
                }}</a>
              </p>
              <p
                class="detail-info"
                v-else-if="item.type === FORM_TYPE.RADIO && item.isHtml"
              >
                <span v-html="getDisplayValue(item, item.model)" />
              </p>
              <p class="detail-info" v-else>
                <span>{{ getDisplayValue(item, item.model) }}</span>
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
/* This component is used to detail information of fields by rows*/
import { FORM_TYPE, FILE_TYPES } from "../../constants/custom-define-type";
import { MODEL_USER_PHONE_FIELD } from "../../constants/model-by-types";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DetailSectionRowLayout",
  components: {
    RatingGroupDetail: () =>
      import("../common/complex-detail-elements/RatingGroupDetail"),
    RadioTableDetail: () =>
      import("../common/complex-detail-elements/RadioTableDetail"),
    CheckboxGroupDetail: () =>
      import("../common/form-elements/CheckboxGroupDetail"),
    ProductSelectionDetail: () =>
      import("./complex-detail-elements/ProductSelectionDetail.vue"),
    StarRating: () => import("./complex-input-elements/StarRating.vue"),
    CheckboxTable: () => import("./complex-input-elements/CheckboxTable.vue"),
    HtmlSelectionDetail: () =>
      import("./complex-detail-elements/HtmlSelectionDetail.vue"),
    DayHourSelectorDetail: () =>
      import("./complex-detail-elements/DayHourSelectorDetail.vue"),
    SignatureDetail: () => import("./complex-detail-elements/SignatureDetail"),
  },
  props: {
    listFields: {
      type: Array,
      default: () => [],
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label",
    },
    listExcludeFields: {
      type: Array,
      default: () => [],
    },
    listHiddenIconFields: {
      //Show hidden icon next to field label
      type: Array,
      default: () => [],
    },
    listAdminOnlyIconFields: {
      type: Array,
      default: () => [],
    },
    hiddenIconTooltip: String,
    visibleIconTooltip: String,
    user: Object,
    tagData: Object,
    isInlineAnswer: {
      type: Boolean,
      default: false,
    },
    hideDescription: {
      type: Boolean,
      default: false,
    },
    hideLabelSpacing: {
      type: Boolean,
      default: false,
    },
    builderField: Object,
  },
  data: function () {
    return {
      FORM_TYPE: FORM_TYPE,
      FILE_TYPES: FILE_TYPES,
    };
  },
  computed: {
    ...mapGetters([
      "agencyCurrency",
      "multipleFillersShiftJob",
      "listJobIdFillers",
      "isAgent",
    ]),
    isPrivateSection() {
      return this.builderField && this.builderField.isPrivate;
    },
    listRowInput() {
      return this.listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [...accResult, [cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        if (this.isFullBootstrapRow(lastEl)) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        // If need to display total years, add a field after end_date to display total years
        // if (this.hasTotalYearsFields && cur.model === "end_date") {
        //   accResult[accResult.length - 1].push({
        //     itemPerRow: 3,
        //     type: FORM_TYPE.TOTAL_YEARS,
        //     label: "Total Years",
        //   });
        // }
        return accResult;
      }, []);
    },
    hasTotalYearsFields() {
      const hasStartDateField = this.listFields.some(
        (field) => field.model === "start_date"
      );
      const hasEndDateField = this.listFields.some(
        (field) => field.model === "end_date"
      );
      return hasStartDateField && hasEndDateField;
    },
    editAccess() {
      if (!this.user || !this.user.id) {
        // Don't consider about edit access
        return null;
      }
      if (
        this.user.id == this.$store.getters.userID ||
        this.$store.getters.isAgent === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    language() {
      return this.$store.getters.language;
    },
  },
  methods: {
    ...mapActions(["handleUpdateBuilderField", "reloadProfileBuilderList"]),
    getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (key === "label" && item.keyLangLabel) {
        return this.getLabelByKeys(item.keyLangLabel);
      }
      if (key === "description") {
        if (this.hideDescription) {
          return "";
        }
        if (item.hideDescriptionInViewScreen) {
          return "";
        }
      }
      if (key === "adminDescription" && item.hideAdminDescriptionInViewScreen) {
        return "";
      }
      if (!this.language) {
        return item[key];
      }
      if (item[key + "_lang_" + this.language]) {
        return item[key + "_lang_" + this.language];
      }
      return item[key];
    },
    getMapOptionListByLanguage(item) {
      if (!item.optionList) {
        return {};
      }
      let listOptionsByLangs;
      if (item.keyLangOptions) {
        listOptionsByLangs = this.getLabelByKeys(item.keyLangOptions);
      } else {
        if (!this.language) {
          return {};
        }
        if (!item["optionList_lang_" + this.language]) {
          return {};
        }
        listOptionsByLangs = this.convertStringToArray(
          item["optionList_lang_" + this.language]
        );
      }
      const listOptions = this.convertStringToArray(item.optionList);
      const result = {};
      for (let index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },
    showDeleteFile(item) {
      // User can delete if the file is not required
      if (this.user && this.user.id == this.$store.getters.userID) {
        return !item.isRequired;
      }
      return false;
    },
    hasAccessibleRelationship(item) {
      // Non login user
      if (!this.$store.getters.userID) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      const listAccessStatus = item.relationshipStatusAccessible;
      if (!listAccessStatus || !listAccessStatus.length) {
        return false;
      }
      if (!this.user.employers) {
        return false;
      }
      // Find logging in user in the list of relationship
      const relationship = this.user.employers.find(
        (relationship) =>
          relationship.employer === this.$store.getters.userID &&
          listAccessStatus.includes(relationship.status)
      );
      if (!relationship) {
        return false;
      }
      return true;
    },
    // Check if the field is visible to filler (candidate view private field of employer)
    isVisibleByFiller(item) {
      // Non login user
      if (!this.$store.getters.userID) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      if (!item.visibleToFiller) {
        return false;
      }
      if (!this.user.jobs) {
        return false;
      }
      // Check if there is at least 1 job which is assigned to the candidate
      if (this.multipleFillersShiftJob) {
        return this.user.jobs.some(
          (job) => job.filled && this.listJobIdFillers.includes(job.id)
        );
      } else {
        return this.user.jobs.some(
          (job) => job.filled && job.filler === this.$store.getters.userID
        );
      }
    },
    getClassList(item) {
      // Check in case need to display total years in experience dialog
      if (["start_date", "end_date"].includes(item.model)) {
        if (this.hasTotalYearsFields) {
          return "col-lg-4";
        }
      }
      if (item.type === FORM_TYPE.FILE && item.showAtTop) {
        return "";
      }
      if (item.type !== FORM_TYPE.TAG_HTML) {
        // Not keep space if item is not displayed
        if (!this.isDisplayItem(item)) {
          return "";
        }
      }

      const itemPerRow = item.itemPerRow;
      if (itemPerRow === 0) {
        return "col";
      }
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    isDisplayItem(item) {
      if (item.type === FORM_TYPE.TOTAL_YEARS) {
        return true;
      }
      if (item.type === FORM_TYPE.LIST_ITEMS) {
        return true;
      }
      if (
        this.listExcludeFields.includes(
          item.isShareModel
            ? `${item.model}-${item.shareModelIndex}`
            : item.model
        )
      ) {
        return false;
      }
      if (item.model === "password") {
        return false;
      }
      if (item.type === FORM_TYPE.CHECKBOX_CONDITION) {
        return false;
      }
      if (
        ![FORM_TYPE.LABEL, FORM_TYPE.HTML].includes(item.type) &&
        item.model == null
      ) {
        return false;
      }
      // Private item is not showed in public access
      if (item.isPrivate && this.editAccess === false) {
        if (
          !this.hasAccessibleRelationship(item) &&
          !this.isVisibleByFiller(item)
        ) {
          return false;
        }
      }
      if (!this.isItemShow(this.modelData, item, this.listFields)) {
        return false;
      }
      if (item.type === FORM_TYPE.LABEL) {
        return true;
      }
      if (this.isMissingField(this.modelData, item)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue(item, key) {
      if (item.type === FORM_TYPE.TOTAL_YEARS) {
        return this.calculateDiffYears(
          this.modelData.start_date,
          this.modelData.end_date
        );
      }
      if (item.type === FORM_TYPE.LABEL) {
        return item.model;
      }
      if (item.type === FORM_TYPE.LIST_ITEMS) {
        return item.itemList;
      }
      let value = this.getValueOfObjectKey(this.modelData, key);
      if (MODEL_USER_PHONE_FIELD.includes(key)) {
        value = this.getDisplayPhone(value);
      }
      if (item.type === FORM_TYPE.LIST_DATE_TIMES_PICKER) {
        return value.map((item) => item.date).join("\n");
      }
      // Check to display multi-languages
      if (item.optionList && this.language) {
        const mapOptionList = this.getMapOptionListByLanguage(item);
        if (mapOptionList) {
          if (Array.isArray(value)) {
            const valueByLang = [];
            for (const valueElement of value) {
              const valueElementByLang = mapOptionList[valueElement];
              if (valueElementByLang) {
                valueByLang.push(valueElementByLang);
              } else {
                valueByLang.push(valueElement);
              }
            }
            value = valueByLang;
          } else if (typeof value === "string") {
            const valueByLang = mapOptionList[value];
            if (valueByLang) {
              value = valueByLang;
            }
          }
        }
      }
      // Check share model
      if (item.isShareModel && Array.isArray(value)) {
        if (value[item.shareModelIndex]) {
          let result = value[item.shareModelIndex];
          if (item.type === FORM_TYPE.RADIO) {
            result = this.removeOtherRadioPrefix(result);
          }
          return result;
        } else {
          return "";
        }
      }
      if (item.type === FORM_TYPE.SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        if (item.hidePeriod) {
          return `From: ${this.currencySign(this.agencyCurrency)}${
            value[0]
          } To: ${this.currencySign(this.agencyCurrency)}${value[1]}`;
        } else {
          return `From: ${this.currencySign(this.agencyCurrency)}${
            value[0]
          } To: ${this.currencySign(this.agencyCurrency)}${value[1]} per ${
            value[2]
          }`;
        }
      } else if (item.type === FORM_TYPE.MONTH_PICKER) {
        return this.getDisplayMonthYear(value);
      }
      // Convert display of multiselect values with option label, option model
      if (item.type === FORM_TYPE.MULTI_SELECT) {
        if (item.optionModel && item.optionLabel) {
          const optionList =
            this.getOptionsListByLanguage(item) || item.optionListAll;
          if (optionList) {
            if (Array.isArray(value)) {
              value = value.map((selectedOptionModel) => {
                const selectedOption = optionList.find(
                  (option) => option[item.optionModel] === selectedOptionModel
                );
                if (selectedOption) {
                  return selectedOption[item.optionLabel];
                }
                return selectedOptionModel;
              });
            } else {
              const selectedOption = optionList.find(
                (option) => option[item.optionModel] === value
              );
              if (selectedOption) {
                value = selectedOption[item.optionLabel];
              }
            }
          }
        }
      }

      if (Array.isArray(value)) {
        return value.join("\n");
      }
      if (typeof value === "boolean") {
        return value
          ? this.getLabelByKeys("OPTIONS.YES")
          : this.getLabelByKeys("OPTIONS.NO");
      }
      if (item.type === FORM_TYPE.FILE) {
        if (item.fileType === FILE_TYPES.IMAGE) {
          // If it is a image file, create URL to display image
          if (typeof value === "object" && value != null) {
            return URL.createObjectURL(value);
          }
        }
      } else if (item.type === FORM_TYPE.TIME_PICKER) {
        if (typeof value === "object") {
          return this.convertTimeAMPMToString(value);
        } else {
          return this.convertTimeStringToStringAMPM(value);
        }
      } else if (item.type === FORM_TYPE.DATEPICKER) {
        let dateValue = this.tryGet(() => this.getDateString(value)) || value;
        if (item.dateFormat) {
          dateValue = this.convertDate(value, "YYYY-MM-DD", item.dateFormat);
        }
        try {
          if (this.showAge(item)) {
            return this.calculateAgeInMonthsAndYears(value);
          }
          if (item.showPassedTime) {
            return (
              dateValue + " (" + this.calculateAgeInMonthsAndYears(value) + ")"
            );
          }
          if (
            item.model === "birthday" ||
            this.tryGet(() => item.others).includes("Show Age")
          ) {
            return (
              dateValue +
              " (Age: " +
              this.calculateAgeInMonthsAndYears(value) +
              ")"
            );
          }
          return dateValue;
        } catch (e) {
          return value;
        }
      } else if (item.type === FORM_TYPE.DATETIME_PICKER) {
        try {
          return new Date(value).toUTCString();
        } catch (e) {
          return value;
        }
      } else if (item.type === FORM_TYPE.YEAR_PICKER) {
        return this.getYearFromDate(value);
      } else if (item.type === FORM_TYPE.LOGGING) {
        if (item.logItem === "Date Time") {
          if (value) {
            return new Date(value);
          }
        }
      } else if (
        [FORM_TYPE.RADIO, FORM_TYPE.MULTI_SELECT].includes(item.type)
      ) {
        value = this.removeOtherRadioPrefix(value);
      }
      return value;
    },
    // Get label which is displayed in detail profile
    getDisplayLabel(item) {
      if (item.hideDetailLabel) {
        return null;
      }
      let result;
      // If keyLanglabel is defined, use it as label
      if (item.keyLangLabel && !item[this.labelKey]) {
        result = this.getLabelByKeys(item.keyLangLabel);
      }
      // Check if label is defined by language
      if (this.language) {
        // If labelDetail is defined, it is the displayed label
        if (item["labelKey_lang_" + this.language]) {
          result = item["labelKey_lang_" + this.language];
        }
        // If labelDetail is not defined or is an empty string, the corresponding label will be the displayed label
        if (result == null || result.trim().length === 0) {
          result = item["label_lang_" + this.language];
        }
      }
      // If labelDetail is defined, it is the displayed label
      if (result == null || result.trim().length === 0) {
        if (item[this.labelKey]) {
          result = item[this.labelKey];
        }
      }
      // If labelDetail is not defined or is an empty string, the corresponding label will be the displayed label
      if (result == null || result.trim().length === 0) {
        result = item.label;
      }
      if (result == null) {
        return null;
      }
      result = result.trim();
      // Remove * character at the end of displayed label
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    },
    getOptionsListByLanguage(item) {
      if (this.language) {
        if (item["optionList_lang_" + this.language]) {
          return item["optionList_lang_" + this.language];
        }
      }

      return item.optionList;
    },
    showDeleteFileConfirmDialog(model) {
      this.showConfirmDialog({
        ...this.$store.getters.deleteFileConfirmDialog,
        onAcceptCallback: this.deleteFile,
        onAcceptCallbackData: model,
      });
    },
    deleteFile(model) {
      this.$emit("deleteModel", model);
    },
    showAge(item) {
      return (
        !this.editAccess &&
        (item.model === "birthday" ||
          this.tryGet(() => item.others).includes("Show Age"))
      );
    },
    handleClickToggleVisibility(item, isVisible) {
      if (!this.isAgent) {
        return;
      }
      if (!this.builderField || !this.builderField.sectionBuilderId) {
        return;
      }
      this.showConfirmDialog({
        key: isVisible
          ? "MAKE_FIELD_VISIBLE_CONFIRM_DIALOG"
          : "MAKE_FIELD_HIDDEN_CONFIRM_DIALOG",
        onAcceptCallback: async () => {
          const requestBody = {
            model: item.model,
            isPrivate: !isVisible,
          };
          const res = await this.handleUpdateBuilderField({
            builderId: this.builderField.sectionBuilderId,
            requestBody: requestBody,
          });
          if (res) {
            this.reloadProfileBuilderList();
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.detail-info {
  white-space: pre-wrap;
}

.sub-header-detail,
.header-detail {
  margin-top: 1.25em;
  margin-bottom: -0.5em;
  padding-left: 15px;
}

.sub-header-detail > h5 {
  margin-bottom: 0;
}

.label-no-margin-top .sub-header-detail {
  margin-bottom: 0.5em;
}

.label-no-margin-top .header-detail {
  margin-bottom: 0.5em;
}

.col-lg-12 > .sub-header-detail {
  padding-left: 0;
}

.image-display {
  max-width: 100%;
  max-height: 10em;
}

.image-at-top {
  max-width: 100%;
  max-height: 10em;
  position: absolute;
  top: 0;
  right: 1.5em;
}

.field-of-fields {
  position: relative;
}

.space-empty-label {
  margin-top: 12px;
}

.display-label {
  display: inline-flex;
  align-items: center;
}

.display-label > i.material-icons {
  font-size: 18px;
}

.field-of-fields.no-label-margin label {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DetailSectionRowLayout.vue